import React from 'react';
import { Check } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function About() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  const usps = ['Boutique Studio exklusiv für Frauen', 'Kleine Gruppen & persönliche Betreuung', 'Stretching, Aerial, TRX, Barre & Mobility', 'Zentral in Nürnberg gelegen'];
  return <section id="about" className="py-24 bg-gradient-to-b from-white to-peony-50 overflow-hidden" data-id="element-2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3">
        <div ref={ref} className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-4">
          {/* Image Side */}
          <div className={`relative ${isVisible ? 'animate-slide-in-left' : 'opacity-0'}`} data-id="element-5">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/5] group" data-id="element-6">
              {/* Real Studio Image */}
              <div className="absolute inset-0 bg-dark-studio/20 group-hover:bg-dark-studio/10 transition-colors duration-500 z-10" data-id="element-7"></div>
              <img src="https://cdn.magicpatterns.com/uploads/6TmBJQi2frrrUVhhPxPSMq/image00031.jpg" alt="Flex Club Studio Atmosphäre" className="w-full h-full object-cover object-center transform group-hover:scale-105 transition-transform duration-700" data-id="element-8" />

              {/* Floating Badge */}
              <div className="absolute bottom-8 right-8 z-20 bg-white/90 backdrop-blur-md p-6 rounded-xl shadow-lg max-w-xs" data-id="element-9">
                <p className="text-dark-studio font-bold text-lg" data-id="element-10">
                  "Ein Ort zum Wohlfühlen"
                </p>
                <div className="flex text-peony-500 mt-2" data-id="element-11">★★★★★</div>
              </div>
            </div>

            {/* Decorative background blob */}
            <div className="absolute -top-10 -left-10 w-full h-full bg-peony-200 rounded-2xl -z-10 transform -rotate-3" data-id="element-12"></div>
          </div>

          {/* Text Side */}
          <div className={`space-y-8 ${isVisible ? 'animate-slide-in-right' : 'opacity-0'}`} data-id="element-13">
            <div data-id="element-14">
              <span className="text-peony-600 font-semibold tracking-wider uppercase text-sm" data-id="element-15">
                Über uns
              </span>
              <h2 className="text-4xl md:text-5xl font-bold text-dark-studio mt-2 mb-6" data-id="element-16">
                Dein Boutique Studio in Nürnberg
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-17">
                Bei Flex & Flow geht es nicht nur um Fitness – es geht um dich.
                In unserem exklusiven Studio für Frauen schaffen wir einen Raum,
                in dem du Kraft tanken, deine Beweglichkeit verbessern und
                einfach du selbst sein kannst.
              </p>
            </div>

            <ul className="space-y-4" data-id="element-18">
              {usps.map((usp, index) => <li key={index} className="flex items-center space-x-3" data-id="element-19">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-peony-100 flex items-center justify-center text-peony-600" data-id="element-20">
                    <Check size={14} strokeWidth={3} data-id="element-21" />
                  </div>
                  <span className="text-gray-700 font-medium" data-id="element-22">{usp}</span>
                </li>)}
            </ul>

            <div className="pt-4" data-id="element-23">
              <a href="#courses" className="inline-flex items-center text-peony-600 font-bold hover:text-peony-800 transition-colors group" data-id="element-24">
                Mehr erfahren
                <span className="ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-25">
                  →
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}